import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../components/modal/Dialog";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { BuyerNewConnectionCommentThreadDialogContent } from "./BuyerNewConnectionCommentThreadDialogContent";
import { SupplierNewConnectionCommentThreadDialogContent } from "./SupplierNewConnectionCommentThreadDialogContent";

export const NewConnectionCommentThreadModal = ({
  active,
  setActive,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
}) => {
  const { business } = useSellarCurrentBusiness();
  const onDismiss = () => setActive(false);
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={""}
        description={``}
      />
      <DialogContent className={"p-4"}>
        {business?.Supplier ? (
          <SupplierNewConnectionCommentThreadDialogContent
            setDialogActive={setActive}
          />
        ) : (
          <BuyerNewConnectionCommentThreadDialogContent
            setDialogActive={setActive}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
